import Vue from "vue";
import confirmAlertMixin from "../mixins/confirmAlert";

Vue.mixin(confirmAlertMixin);
